/** ***************
 ***** Roles *****
 **************** */

export enum SystemRolesIds {
  Admin = "SystemAdmin",
}

export enum UserRoleIds {
  Read = "UserStandardSystemRole",
  Write = "UserAsSelf",
}

export enum WorkspaceRoleIds {
  Read = "WorkspaceViewOnly",
  Write = "WorkspaceAdmin",
}

export enum OrgRoleIds {
  Admin = 'OrganizationAdmin',
  Member = 'OrganizationMember',
  Owner = 'OrganizationOwner',
  ViewOnly = 'OrganizationViewOnly',
  Read = OrgRoleIds.ViewOnly,
  Write = OrgRoleIds.Admin,
}

export type RoleIds =
  | SystemRolesIds
  | UserRoleIds
  | WorkspaceRoleIds
  | OrgRoleIds;

/** *****************
 ***** Actions *****
 ****************** */

export enum TopLevelActions {
  CreateOrganizations = "CreateOrganizations",
  CreateUsers = "CreateUsers",
  ViewRoles = "ViewRoles",
}

export enum OrganizationActions {
  ViewOrganization = "ViewOrganization",
  ModifyOrganization = "ModifyOrganization",
  DeleteOrganization = "DeleteOrganization",
  ViewOrganizationPermissions = "ViewOrganizationPermissions",
  ModifyOrganizationPermission = "ModifyOrganizationPermission",
  DeleteOrganizationPermission = "DeleteOrganizationPermission",
  ViewOrganizationRoleAttachments = "ViewOrganizationRoleAttachments",
  ModifyOrganizationRoleAttachments = "ModifyOrganizationRoleAttachments",
  DeleteOrganizationRoleAttachments = "DeleteOrganizationRoleAttachments",
  CreateWorkspaces = "CreateWorkspaces",
  ViewWorkspaces = "ViewWorkspaces",
}

export enum UserActions {
  ViewUser = "ViewUser",
  TestUserPermissions = "TestUserPermissions",
  ModifyUser = "ModifyUser",
  DeleteUser = "DeleteUser",
}

export enum WorkspaceActions {
  ViewWorkspace = "ViewWorkspace",
  ModifyWorkspace = "ModifyWorkspace",
  DeleteWorkspace = "DeleteWorkspace",
  ViewWorkspacePermissions = "ViewWorkspacePermissions",
  ModifyWorkspacePermission = "ModifyWorkspacePermission",
  DeleteWorkspacePermission = "DeleteWorkspacePermission",
  ViewWorkspaceRoleAttachments = "ViewWorkspaceRoleAttachments",
  ModifyWorkspaceRoleAttachments = "ModifyWorkspaceRoleAttachments",
  DeleteWorkspaceRoleAttachment = "DeleteWorkspaceRoleAttachment",
  StopWorkspace = "StopWorkspace",
  StartWorkspace = "StartWorkspace",
  ResetWorkspace = "ResetWorkspace",
}

export enum WorkspaceGroupActions {
  ViewWorkspaceGroup = "ViewWorkspaceGroup",
}

export enum WorkspaceTemplateActions {
  ViewWorkspaceTemplate = "ViewWorkspaceTemplate",
}

export type Actions =
  | TopLevelActions
  | OrganizationActions
  | UserActions
  | WorkspaceActions
  | WorkspaceGroupActions
  | WorkspaceTemplateActions;

export default interface IRole {
  actions: Array<Actions>;
  id: RoleIds;
}
